import { render, staticRenderFns } from "./productBatchManagement.vue?vue&type=template&id=5d4ab55c&scoped=true"
import script from "./productBatchManagement.vue?vue&type=script&lang=js"
export * from "./productBatchManagement.vue?vue&type=script&lang=js"
import style0 from "./productBatchManagement.vue?vue&type=style&index=0&id=5d4ab55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ab55c",
  null
  
)

export default component.exports